import React from 'react';
import uniqueId from 'lodash.uniqueid';

class UploadButton extends React.Component {
  // Don't set this in the render
  id = `file-upload-${uniqueId()}`;

  handleKeyDown = event => {
    if (event.keyCode === 13) event.target.click();
  };

  render() {
    return (
      <label
        aria-label={this.props.ariaLabel}
        className='btn upload-button btn-primary btn-lg font-weight-bold'
        tabIndex='0'
        htmlFor={this.id}
        role='button'
        onKeyDown={this.handleKeyDown}
      >
        {this.props.label}

        <input
          id={this.id}
          type='file'
          className='d-none'
          multiple
          accept={this.props.fileValidator.acceptFileTypeString}
          onChange={this.props.onChange}
        />
      </label>
    );
  }
};

export default UploadButton;
